fx.ns("shared.stage", class InfoBubble extends fx.Component {

    constructor(frame)
    {
        super();

        this._frame = frame;

        this.effect = "fade";
    }

    get info()
    {
        return this._info;
    }

    set info(val)
    {
        this._info = val;
    }

    get scale()
    {
        return this._scale;
    }

    set scale(val)
    {
        this._scale = val;
    }


    show()
    {
        if (fx.get("app") != "config")
            return;
        
        if (this.visible)
            this.update();
        else
            super.show();
    }

    resize()
    {
        this.scale = 1/ (this._frame && this._frame.currentArea ? this._frame.currentArea.scale : 1);
        this.css({transform : "scale(" + this.scale + ")"});
    }

    position()
    {
        if (this._frame && this._frame.borderContainer)
        {
            let bubbleTop = parseFloat(fx.dom.css(this._frame.borderContainer,"top")) - this.realHeight * this.scale;
            this.css({top : bubbleTop, left : fx.dom.css(this._frame.borderContainer, "left")});
        }
    }


    update(force)
	{
		this._update();
	}


    render()
    {
        if (this._frame && this._frame.currentElement && this._frame.currentElement.data)
        {
            if (this.info == "resize")
                return parseInt(this._frame.currentElement.width) + " x " + parseInt(this._frame.currentElement.height) + ' mm';
            else
                return parseInt(this._frame.currentElement.rotation) + " degré" + ((this._frame.currentElement.rotation > 1) ? "s" : "");
        }
        else
            return "";
    }


});